// extracted by mini-css-extract-plugin
export var container = "style-mod--container--4a8f4";
export var countdown = "style-mod--countdown--caf33";
export var countdownTitle = "style-mod--countdown-title--58c23";
export var dots = "style-mod--dots--73c51";
export var number = "style-mod--number--68034";
export var text = "style-mod--text--ea1ec";
export var timer = "style-mod--timer--3294c";